import { NgModule } from '@angular/core';

import { CompanyActionsComponent }      from './company.actions.component';
import { CompanyAdminStatusPipe }       from './company.admin-status.pipe';
import { CompanyCustomizationsService } from './company.customizations.service';
import { SharedModule }                 from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    // Components
    CompanyActionsComponent,

    // Pipes
    CompanyAdminStatusPipe
  ],
  entryComponents: [
    CompanyActionsComponent,
  ],
  exports: [
    // Components
    CompanyActionsComponent,
  ],
  imports: [
    SharedModule
  ],
  providers: [
    CompanyAdminStatusPipe,
    CompanyCustomizationsService,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'companyAdminStatus',
      useClass: CompanyAdminStatusPipe
    }
  ]
})
export class CompaniesModule {}
